<template>
  <div
    class="p-4 bg-white card multisteps-form__panel border-radius-xl shadow-sm"
    data-animation="FadeIn"
  >
    <!-- Título -->
    <h5 class="font-weight-bolder mb-3">Configurações</h5>

    <div class="multisteps-form__content">

      <!-- Botões Navegação -->
      <div class="d-flex flex-wrap gap-2 mt-2 mb-4">
        <argon-button
          color="secondary"
          variant="gradient"
          class="js-btn-prev"
          title="Prev"
          @click="$parent.prevStep"
        >
          ← Voltar
        </argon-button>

        <argon-button
          type="button"
          color="dark"
          variant="gradient"
          class="ms-auto js-btn-next"
          title="Next"
          @click="$parent.nextStep"
        >
          Próximo →
        </argon-button>
      </div>

      <!-- Opções -->
      <div class="table-responsive p-0">

         <div class="py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between">
          <label class="mb-0 fw-bold fs-5">Acumular Rotas</label>
          <div class="form-check form-switch m-0">
            <input
              class="form-check-input"
              v-model="configuracao.acumular"
              type="checkbox"
            />
          </div>
        </div>

        <div class="py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between">
          <label class="mb-0 fw-bold fs-5">Respeitar Horário das Janelas</label>
          <div class="form-check form-switch m-0">
            <input
              class="form-check-input"
              v-model="configuracao.horarios"
              type="checkbox"
            />
          </div>
        </div>

        <div class="py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between">
          <label class="mb-0 fw-bold fs-5">Menor Distância</label>
          <div class="form-check form-switch m-0">
            <input
              class="form-check-input"
              v-model="configuracao.distancia"
              type="checkbox"
            />
          </div>
        </div>

        <div class="py-3 px-3 mb-3 border rounded d-flex align-items-center justify-content-between">
          <label class="mb-0 fw-bold fs-5">Ordem de Chegada</label>
          <div class="form-check form-switch m-0">
            <input
              class="form-check-input"
              v-model="configuracao.ordenar"
              type="checkbox"
            />
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "Socials",
  components: {
    ArgonInput,
    ArgonButton
  },
  props: {
    configuracao: {
      type: Object, // estava Array (provavelmente incorreto)
      default: () => ({})
    }
  }
};
</script>
